import { Link } from 'react-router-dom';

import { useStation } from '../../core/stations/hooks/useStation';

export function StationLink({ id, link }: { id: string; link: string }) {
  const station = useStation(id);

  if (!station) {
    return null;
  }

  return <Link to={link}>{station.name}</Link>;
}
